export default {
  INGREDIENTS: (state) => state.ingredients,
  INGREDIENT_CATEGORIES: (state) => state.ingredientCategories,
};
